<template>
    <div class="w-100">
        <c-column-header
            v-if   = "title"
            :label = "title"
            class  = "primary"
        >
            <template v-slot:filter>
                <div class="c-toolbar">
                    <c-toolbar-button
                        icon     = "mdi-reload"
                        :tooltip = "$t('dms.tree.reload')"
                        color    = "white"
                        size     = "20"
                        @click   = "onReload"
                    />
                </div>
            </template>
        </c-column-header>

        <div
            class  = "tree-scroll-panel"
            :class = "border ? 'lm-border' : null"
        >
            <v-treeview
                :items        = "folder"
                item-key      = "id"
                item-text     = "name"
                item-children = "entries"
                :style = "'height: ' + height + 'px'"
                hoverable
                dense
            >
                <template v-slot:label="{ item, open }">
                    <div class="v-flex">
                        <div class="no-frame" style="width: 70%">
                            <div class="v-flex" v-if  = "item.type === 3">
                                <p-dms-treeview-folder
                                    :folder = "item"
                                    :open   = "open"
                                />
                            </div>

                            <p-dms-treeview-file
                                :item     = "item"
                                @document = "onDocument"
                            />
                         </div>
                    </div>
                </template>
            </v-treeview>
        </div>
    </div>
</template>

<script>

import Core               from "@/modules/core/service/Core";
import CColumnHeader      from "@/modules/core/components/utils/CColumnHeader.vue";
import CToolbarButton     from "@/modules/core/components/utils/CToolbarButton.vue";
import PDmsTreeviewFile   from "@/modules/dms/treeview/components/private/PDmsTreeviewFile.vue";
import PDmsTreeviewFolder from "@/modules/dms/treeview/components/private/PDmsTreeviewFolder.vue";

export default {
    name: "PDmsTreeview",

    components: {
        PDmsTreeviewFile,
        PDmsTreeviewFolder,
        CToolbarButton,
        CColumnHeader,
    },

    props: {
        title: {

        },

        folder: {

        },

        border: {
            required: false,
            type    : Boolean,
            default : () => {
                return false;
            }
        },

        height: {

        }
    },

    data: () => ({
        selected: null,
        document: null,
        menu: {
            show: false,
        }
    }),

    methods: {
        onReload () {
            this.$emit("reload");
        },

        onDocument (document) {
            if (this.selected && this.selected.id === document.id) {
                this.selected = null;
                this.document = null;
                Core.fire.selected(this, null);
                return;
            }

            this.selected = document;
            this.$nextTick(() => {
                this.document = document.id
            });

            Core.fire.selected(this, this.selected);
        },
    }
}
</script>

<style scoped>

.tree-scroll-panel  {
    margin-top: 4px;
    overflow-y: scroll;
}

::v-deep .theme--light.v-icon:focus:after {
    opacity: 0;
}

::v-deep .v-treeview--dense .v-treeview-node__root {
    min-height: 30px;
}

::v-deep .v-treeview-node__content {
    margin-left: 0;
}

</style>